export default __webpack_public_path__ + "static/media/DF_Logo_Large.9a31f2ac.png";